<template lang="pug">

  section(class="question")
    Thanks(v-if="!actualQuestion")
    .form(v-else)
      h1 {{actualQuestion.title}}
      nav
        button(v-for="(option, index) in actualQuestion.options" @click.stop="respondQuestion(index)" :key="index") {{option.text}}
    modals-container
</template>

<script>
  import { mapActions, mapGetters } from 'vuex'
  import Answer from '@/components/trivia/Answer'
  import Thanks from '@/components/trivia/Thanks'
  export default  {
    name: 'question',
    components: {
      Answer,
      Thanks
    },
    methods: {
      ...mapActions([
        'setAnswer'
      ]),
      respondQuestion(index) {
        this.$ga.event('trivia', 'respond', 'question', this.actualQuestion.id)

        if(this.actualQuestion.options[index].correct){
          this.showAnswer(true, '¡Muy bien!')
          setTimeout(()=>{
            this.setAnswer({
              question: this.actualQuestion,
              answered: true,
              result: true
            })
          }, 500)
        } else {
          this.showAnswer(false, this.actualQuestion.badtext)
          setTimeout(()=>{
            this.setAnswer({
              question: this.actualQuestion,
              answered: true,
              result: false
            })
          }, 500)
        }
      },
      showAnswer(correct, text) {
        this.$modal.show(Answer, {
          text
        }, {
          clickToClose: false,
          transition: 'modaltransition',
          width: '90%'
        })
      },
    },
    computed: {
      ...mapGetters([
        'actualQuestion'
      ])
    }
}
</script>

<style scoped lang="scss">
  h1{
    text-align: center;
    font-family: 'Oswald', sans-serif;
    @include fluid-type(360px,
      1440px,
      21px,
      36px);
    line-height: 100%;
  }
  nav{
    padding: 2rem;
  }
  button{
    background-color: rgba(white, 0.2);
    display: block;
    cursor: pointer;
    font-size: 1.6rem;
    padding: 1rem;
    width: 100%;
    margin-bottom: 1rem;
    border: 2px solid white;
    color: white;
    text-size-adjust: 100%;
    font-family: 'Oswald', sans-serif;
    font-weight: 700;
    transition: all .3s;
    &:hover{
      background-color: white;
      color: cornflowerblue;
    }
  }

</style>
